import { render } from "./PreDefinedFilters.vue?vue&type=template&id=0ffa4caf"
import script from "./PreDefinedFilters.vue?vue&type=script&lang=js"
export * from "./PreDefinedFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__